import React, { useEffect, useState } from "react";
import "./othersmodule.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Skeleton,
  Box,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import CustomPagination from "../common/CustomPagination ";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import LogRecordMessageBox from "./LogRecordMessageBox";
import OriginalMessage from "./Original_message";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment/moment";

const LogRecords = () => {
  const boxStyle = {
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: 1,
    height: "fit-Content",
  };
  const [sortObj, setSortObj] = useState({
    name: "message_log_timestamp",
    order: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [MessageLogTableData, setMessageLogTableData] = useState([]);
  const [searchmessage, setSearchMessage] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [backDrop, setBackDrop] = useState(false);
  const totalPages = Math.ceil(totalRecods / 10);
  const [loader, setLoader] = useState(true);
  const [backgroundColor, setBackgroundColor] = useState({
    MsgColor: false,
    Searchcolor: false,
    datecolor: false,
  });
  const [wildcraftfilter, setWildcraftfilter] = useState({
    MsgType: "",
    Source: "",
    Destination: "",
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [checked, setChecked] = useState({
    to: { value: 1, isSelected: true },
    from: { value: 1, isSelected: true },
  });
  const [newDialogOpen, setNewDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});

  const getLogRecords = (
    pageNumber = currentPage,
    searchinfo = searchValue,
    isdateselected,
    isChecked = checked
  ) => {
    const body = {
      id: "",
      searchtext: searchinfo,
      pageno: pageNumber,
      fromdate: isdateselected
        ? fromDate
          ? moment(fromDate).format("YYYY-MM-DD")
          : ""
        : "",
      todate: isdateselected
        ? toDate
          ? moment(toDate).format("YYYY-MM-DD")
          : ""
        : "",
      pagesize: 10,
      sortby: sortObj.name,
      sortord: sortObj.order,
      message_direction: `${isChecked.to.value}${isChecked.from.value}`,
    };
    instance
      .post("api/v1/Message/GetMessageLog", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          setMessageLogTableData(() => {
            return [...(res?.data?.Value ?? [])];
          });
        } else {
          setTotalRecods(0);
          setMessageLogTableData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleChange_check = (event) => {
    function setCheckValue(event) {
      let tempChecked = { ...checked };
      tempChecked[event.target.name]["isSelected"] = event.target.checked;
      tempChecked[event.target.name]["value"] = event.target.checked ? 1 : 0;
      setChecked(tempChecked);

      let searchString = buildSearchString(backgroundColor);
      getLogRecords(1, searchString, true, tempChecked);
    }
    if (checked.to.isSelected && checked.from.isSelected) {
      setCheckValue(event);
    } else if (checked[event.target.name].isSelected == false) {
      setCheckValue(event);
    }
  };
  const handleChange = (event) => {
    const numericValue = event.target.value.replace(/[^0-9]/g, "");
    console.log(event.target.value, "event.target.value");
    setSearchMessage(numericValue);
  };

  const handleChangeWildFilter = (event) => {
    const { name, value } = event.target;
    console.log("name==", name, value);
    setWildcraftfilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleClearFilter = () => {
    if (
      !wildcraftfilter.MsgType &&
      !wildcraftfilter.Source &&
      !wildcraftfilter.Destination
    ) {
      return;
    }
    let string = "";
    setWildcraftfilter({
      MsgType: "",
      Source: "",
      Destination: "",
    });
    setBackgroundColor((prev) => ({
      ...prev,
      Searchcolor: false,
    }));
    if (searchmessage) {
      string += `message_id=${searchmessage}`;
      getLogRecords(1, string, true);
      setCurrentPage(1);
    } else {
      getLogRecords(1, "", true);
      setCurrentPage(1);
    }
  };
  const handleClick_wildsearch = (msgType, source, destination) => {
    if (!msgType && !source && !destination) {
      return;
    }
    let tempBackground = { ...backgroundColor };
    tempBackground.Searchcolor = true;
    setBackgroundColor(tempBackground);
    let searchString = buildSearchString(tempBackground);
    getLogRecords(1, searchString, false);
    setCurrentPage(1);
  };

  const handleClick_date = () => {
    if (!fromDate && !toDate) {
      return;
    }
    setCurrentPage(1);
    let tempBackground = { ...backgroundColor };
    tempBackground.datecolor = true;
    setBackgroundColor(tempBackground);
    let searchString = buildSearchString(tempBackground);
    getLogRecords(1, searchString, true);
  };
  const handleSearch = () => {
    if (!searchmessage) {
      return;
    }
    setCurrentPage(1);
    let tempBackground = { ...backgroundColor };
    tempBackground.MsgColor = true;
    setBackgroundColor(tempBackground);
    let searchString = buildSearchString(tempBackground);
    getLogRecords(1, searchString, false);
  };
  const buildSearchString = (tempBackground) => {
    let searchString = "";

    if (
      tempBackground.Searchcolor &&
      (wildcraftfilter.MsgType ||
        wildcraftfilter.Source ||
        wildcraftfilter.Destination)
    ) {
      console.log("searchString", tempBackground);
      searchString += `message_type_name like '%${wildcraftfilter.MsgType}%' and entity.entity_name like '%${wildcraftfilter.Source}%' and entity_1.entity_name like '%${wildcraftfilter.Destination}%'`;
    }
    if (tempBackground.MsgColor && searchmessage) {
      searchString += searchString.length
        ? ` and message_id=${searchmessage}`
        : `message_id=${searchmessage}`;
    }
    return searchString;
  };
  const handleClick_datesearch = () => {
    setToDate(null);
    setFromDate(null);
    setBackgroundColor((prev) => ({
      ...prev,
      datecolor: false,
    }));
    let string = "";
    if (
      wildcraftfilter.MsgType ||
      wildcraftfilter.Source ||
      wildcraftfilter.Destination
    ) {
      string += `message_type_name like '%${wildcraftfilter.MsgType}%' and entity.entity_name like '%${wildcraftfilter.Source}%' and entity_1.entity_name like '%${wildcraftfilter.Destination}%'`;
    }
    if (searchmessage) {
      string += string.length
        ? ` and message_id=${searchmessage}`
        : `message_id=${searchmessage}`;
    }
    getLogRecords(1, string, false);
  };
  const handleClick_Msgsearch = () => {
    setSearchMessage("");
    setBackgroundColor((prev) => ({
      ...prev,
      MsgColor: false,
    }));
    let string = "";
    if (
      wildcraftfilter.MsgType ||
      wildcraftfilter.Source ||
      wildcraftfilter.Destination
    ) {
      string += `message_type_name like '%${wildcraftfilter.MsgType}%' and entity.entity_name like '%${wildcraftfilter.Source}%' and entity_1.entity_name like '%${wildcraftfilter.Destination}%'`;
      getLogRecords(1, string);
      setCurrentPage(1);
    } else {
      getLogRecords(1, "");
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    console.log("searchmessage1", searchmessage);
    if (
      searchmessage.length > 0 ||
      wildcraftfilter.MsgType.length > 0 ||
      wildcraftfilter.Source.length > 0 ||
      wildcraftfilter.Destination.length > 0
    ) {
      if (searchmessage) {
        getLogRecords(
          currentPage,
          `message_type_name like '%${wildcraftfilter.MsgType}%' and entity.entity_name like '%${wildcraftfilter.Source}%' and entity_1.entity_name like '%${wildcraftfilter.Destination}%' and message_id=${searchmessage};`
        );
      } else {
        getLogRecords(
          currentPage,
          `message_type_name like '%${wildcraftfilter.MsgType}%' and entity.entity_name like '%${wildcraftfilter.Source}%' and entity_1.entity_name like '%${wildcraftfilter.Destination}%'`
        );
      }
    } else {
      getLogRecords();
    }
  }, [sortObj, currentPage]);

  const handleClick = (originalMessageId, sourceEndpointName) => {
    let selected_direction = "";

    if (sourceEndpointName === "Fro Endpoint") {
      selected_direction = "F";
    } else if (sourceEndpointName === "BolloreSFTP") {
      selected_direction = "T";
    }

    setDialogData({
      originalMessageId,
      sourceEndpointName,
      selected_direction,
    });
    setNewDialogOpen(true);
  };
  const handleClose = () => {
    setNewDialogOpen(false);
  };
  return (
    <div className="parent_divOthr">
      <Grid container mb={2}>
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              {" "}
              <p className="heading_fontOthr">Message Records</p>
              <p className="head_divOthr"></p>
            </Grid>
            <Grid
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
              <Typography
                sx={{ fontSize: "var(--fs-medium)", marginRight: "0rem" }}
              >
                Total Recods - {totalRecods}
              </Typography>
            </Grid>
            <Grid
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography sx={{ marginRight: 4, fontSize: "var(--fs-new)" }}>
                Find Message by using message Id
              </Typography>
              <input
                value={searchmessage}
                type="text"
                // onKeyDown={(event) => {
                //   if (event.key === "Enter") {
                //     setCurrentPage(1);
                //     getLogRecords(1, `message_id=${event.target.value};`);
                //   }
                // }}
                onChange={handleChange}
              />
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  className={`message_div ${
                    backgroundColor.MsgColor ? "background_FilterIcon" : ""
                  }`}
                  onClick={handleSearch}
                >
                  <FilterAltIcon sx={{ fontSize: "small" }} />
                </div>
                <div className="message_div" onClick={handleClick_Msgsearch}>
                  <FilterAltOffIcon sx={{ fontSize: "small" }} />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  style={{ marginRight: "20px" }}
                  label="From Date"
                  value={fromDate}
                  onChange={(newValue) => setFromDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="To Date"
                  value={toDate}
                  onChange={(newValue) => setToDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </LocalizationProvider>
              <div
                style={{
                  display: "flex",
                  marginTop: "1rem",
                }}
              >
                <div
                  className={`message_div ${
                    backgroundColor.datecolor ? "background_FilterIcon" : ""
                  }`}
                  onClick={handleClick_date}
                >
                  <FilterAltIcon sx={{ fontSize: "small" }} />
                </div>
                <div className="message_div" onClick={handleClick_datesearch}>
                  <FilterAltOffIcon sx={{ fontSize: "small" }} />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <Box sx={boxStyle}>
            <Typography
              sx={{
                marginRight: 3,
                fontSize: "var(--fs-new)",
                color: "var(--color-selectedRowText)",
                fontWeight: "bold",
              }}
              mb={1}
            >
              Wildcard Filter
            </Typography>
            <Box display="flex" alignItems="center" mb={1}>
              <div className="d-flex flex-column " style={{ rowGap: "0.5rem" }}>
                <div className="d-flex">
                  <Typography
                    sx={{
                      marginRight: 3,
                      flex: 1,
                      fontSize: "var(--fs-small)",
                    }}
                  >
                    Message Type
                  </Typography>
                  <input
                    sx={{ flex: 2 }}
                    name="MsgType"
                    value={wildcraftfilter.MsgType}
                    type="text"
                    onChange={handleChangeWildFilter}
                  />
                </div>

                <div className="d-flex">
                  <Typography
                    sx={{
                      marginRight: 3,
                      flex: 1,
                      fontSize: "var(--fs-small)",
                    }}
                  >
                    Source
                  </Typography>
                  <input
                    sx={{ flex: 2 }}
                    name="Source"
                    value={wildcraftfilter.Source}
                    type="text"
                    onChange={handleChangeWildFilter}
                  />
                </div>
              </div>

              <div
                className={`wildcraft_div ${
                  backgroundColor.Searchcolor ? "wildcraft_div_IconColor" : ""
                }`}
                onClick={() =>
                  handleClick_wildsearch(
                    wildcraftfilter.MsgType,
                    wildcraftfilter.Source,
                    wildcraftfilter.Destination
                  )
                }
              >
                <SearchIcon />
              </div>
            </Box>
            <Box display="flex" alignItems="center">
              <Typography
                sx={{ marginRight: 3, flex: 1, fontSize: "var(--fs-small)" }}
              >
                Destination
              </Typography>
              <input
                sx={{ flex: 2 }}
                name="Destination"
                value={wildcraftfilter.Destination}
                type="text"
                onChange={handleChangeWildFilter}
              />
              <div className="destination_div" onClick={handleClearFilter}>
                <FilterAltOffIcon sx={{ fontSize: "medium" }} />
              </div>
            </Box>
          </Box>
          <FormGroup row sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked.to.isSelected}
                  onChange={handleChange_check}
                  name="to"
                  color="primary"
                />
              }
              label="To"
              labelPlacement="start"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked.from.isSelected}
                  onChange={handleChange_check}
                  name="from"
                  color="primary"
                />
              }
              label="From"
              labelPlacement="start"
            />
          </FormGroup>
        </Grid>
      </Grid>
      {/* {selectedRowIndex !== null && (
        <LogRecordMessageBox
          setCurrentPage={setCurrentPage}
          setSearchValue={setSearchValue}
          selectedRow={MessageLogTableData[selectedRowIndex]}
          getLogRecordsfilter={getLogRecords}
          setSelectedRowIndex={setSelectedRowIndex}
        />
      )} */}
      {newDialogOpen === true && (
        <OriginalMessage
          open={newDialogOpen}
          handleClose={handleClose}
          originalMessageId={dialogData.originalMessageId}
          sourceEndpointName={dialogData.sourceEndpointName}
          selectedDirection={dialogData.selected_direction}
        />
      )}
      <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow className="Table_rowOthr">
              <StyledTableCell>
                Timestamp{" "}
                {sortObj?.order == "asc" ? (
                  <img
                    onClick={() => {
                      setSortObj((prev) => {
                        return {
                          ...prev,
                          order: "desc",
                        };
                      });
                    }}
                    src="assets/Images/Ascending.svg"
                    alt="Ascending"
                    style={{ width: "13px", marginLeft: "5px" }}
                  />
                ) : (
                  <img
                    onClick={() => {
                      setSortObj((prev) => {
                        return {
                          ...prev,
                          order: "asc",
                        };
                      });
                    }}
                    src="assets/Images/descending.svg"
                    alt="Descending"
                    style={{ width: "13px", marginLeft: "5px" }}
                  />
                )}
              </StyledTableCell>
              <StyledTableCell>Message ID</StyledTableCell>
              <StyledTableCell>Message Type Name</StyledTableCell>
              <StyledTableCell>Message Current Status</StyledTableCell>
              <StyledTableCell>Source Endpoint Name</StyledTableCell>
              <StyledTableCell>Original Message ID</StyledTableCell>
              <StyledTableCell>Source</StyledTableCell>
              <StyledTableCell>Destination</StyledTableCell>
            </TableRow>
          </TableHead>
          {loader ? (
            <>
              {new Array(10).fill(3).map((element, index) => {
                return (
                  <TableRow key={index}>
                    {new Array(8).fill(1).map((element, index) => {
                      return (
                        <TableCell align="center" key={index}>
                          <Skeleton
                            variant="rounded"
                            width={"100%"}
                            height={60}
                          />
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </>
          ) : (
            <>
              {MessageLogTableData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <p>No Data Found</p>
                  </TableCell>
                </TableRow>
              ) : (
                <TableBody>
                  {MessageLogTableData.map((rowData, index) => {
                    const isSelected = selectedRowIndex === index;
                    const rowStyles = {
                      cursor: "pointer",
                      backgroundColor: isSelected
                        ? "var(--color-selectedRowBackGround)"
                        : " ",
                    };
                    const cellTextStyles = {
                      color: isSelected ? "var(--color-selectedRowText)" : " ",
                    };
                    return (
                      <TableRow
                        key={index}
                        style={rowStyles}
                        // onClick={() => setSelectedRowIndex(index)}
                        onClick={(e) => {
                          // Check if the click was on the "Original Message ID" cell
                          // if (e.target.getAttribute("data-column") !== "originalMessageId") {
                          //   setSelectedRowIndex(index);
                          // }
                          setSelectedRowIndex(index);
                          handleClick(
                            rowData?.original_message_identifier ?? "N/A",
                            rowData?.source_endpoint_name ?? "N/A"
                          );
                        }}
                      >
                        <TableCell style={cellTextStyles}>
                          {rowData?.message_creation_timestamp ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.message_Id ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.message_type_name ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.message_status_name ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.source_endpoint_name ?? "N/A"}
                        </TableCell>
                        {/* <TableCell style={cellTextStyles}> */}
                        <TableCell
                          style={cellTextStyles}
                          data-column="originalMessageId"
                          // onClick={(e) => {
                          //   e.stopPropagation(); // Prevent the row click event
                          //   // setSelectedRowIndex(index);
                          //   setNewDialogOpen(true);
                          //   // Add your dialog open logic here for "Original Message ID" column click
                          // }}
                          //             onClick={(e) => {
                          //   e.stopPropagation(); // Prevent the row click event
                          //   if (selectedRowIndex !== null) {
                          //     setSelectedRowIndex(null); // Deselect the row if one is selected
                          //   }
                          //   handleClick(rowData?.original_message_identifier ?? 'N/A', rowData?.source_endpoint_name ?? 'N/A');
                          // }}
                        >
                          {rowData?.original_message_identifier ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.source ?? "N/A"}
                        </TableCell>
                        <TableCell style={cellTextStyles}>
                          {rowData?.Dest ?? "N/A"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              )}
            </>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};
export default LogRecords;
